import CountUp from "react-countup";
import "./StatsItem.css";
import HTMLReactParser from "html-react-parser";

function StatsItem({ stat, duration, delay }) {
  return (
    <div className={`${stat?.class} stat-item`}>
      <h1 className="d-flex justify-content-center align-items-center gap-0">
        <CountUp
          end={stat?.number}
          duration={duration}
          delay={delay}
          decimal=","
          useEasing={true}
          scrollSpyOnce={true}
        />
        <span>{stat?.measure}</span>
      </h1>
      <p className="m-0 p-0 d-flex justify-content-center">{HTMLReactParser(stat?.description)}</p>
    </div>
  );
}

export default StatsItem;
